import React from 'react';

import Analytics from 'app/pages/overview';
import Pairs from 'app/pages/pairs';
import PairsDetails from 'app/pages/pairs-details';
import Tokens from 'app/pages/tokens';
import TokenDetails from 'app/pages/tokens-details';
import Saved from 'app/pages/saved';
import NotFound from 'app/pages/not-found';

import { AppRoutes } from './routes-enum';

export type RoutesType = {
  id: number
  path: string
  status?: number
  Component: React.FC
};

export const routes: RoutesType[] = [
  {
    id: 1,
    path: AppRoutes.OVERVIEW,
    Component: Analytics,
  },
  {
    id: 3,
    path: AppRoutes.PAIRS,
    Component: Pairs,
  },
  {
    id: 4,
    path: AppRoutes.TOKENS,
    Component: Tokens,
  },
  {
    id: 5,
    path: AppRoutes.PAIRS_DETAILS,
    Component: PairsDetails,
  },
  {
    id: 6,
    path: AppRoutes.TOKEN_DETAILS,
    Component: TokenDetails,
  },
  {
    id: 7,
    path: AppRoutes.SAVED,
    Component: Saved,
  },
  {
    id: 8,
    path: AppRoutes.DIFFERENT_ROUTES,
    status: 404,
    Component: NotFound,
  },
];
